import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { DATE } from '../../fields';
import { MONTH_VIDEO_REPORT_ID } from './monthVideoReportId';

const monthReportFooterColumnDefinition = [DATE].map(createFooterMapper(MONTH_VIDEO_REPORT_ID));

export default monthReportFooterColumnDefinition;
